export default __webpack_public_path__ + "static/media/poster.f6548335.jpg";